import { ComponentIds, ConnectionRootComponent, HierarchyUtils, PartPair, ReplaceAssemblyPartUtils, } from "@inter-ikea-core/core";
import { isAdjustableEntityChild } from "../utils/entityUtils";
import { MISSING_BRACKET } from "../constants/errors";
import ProductTypeComponent from "../components/ProductTypeComponent";
export const getMetaDataComponents = (entity) => {
    var _a, _b;
    return (_b = (_a = entity.getComponent(ComponentIds.META_DATA_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.metaData) === null || _b === void 0 ? void 0 : _b.components;
};
export const getEntityTemplateMetaDataComponents = (entity, templates) => {
    var _a, _b, _c;
    const templateId = (_a = entity.getComponent(ComponentIds.TEMPLATE_DATA_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.templateId;
    const template = templates.templates.find((template) => template.templateId === templateId);
    return (_c = (_b = template === null || template === void 0 ? void 0 : template.components) === null || _b === void 0 ? void 0 : _b.meta) === null || _c === void 0 ? void 0 : _c.components;
};
export const replaceProductPart = (entity, partKey, productRef, coreServices) => {
    if (isAdjustableEntityChild(entity)) {
        entity.addComponent(new ConnectionRootComponent());
        const partPair = [new PartPair(partKey, productRef)];
        ReplaceAssemblyPartUtils.replaceProductParts(entity, partPair, coreServices);
        const bracket = HierarchyUtils.descendants(entity).find((d) => {
            var _a;
            return ((_a = d.getComponent(ComponentIds.PRODUCT_PART_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.partKey) === partKey;
        });
        if (!bracket)
            throw new Error(MISSING_BRACKET);
        HierarchyUtils.setParent(bracket, entity);
        entity.removeComponent(ComponentIds.CONNECTION_ROOT_COMPONENT);
    }
    else {
        const partPair = [new PartPair(partKey, productRef)];
        ReplaceAssemblyPartUtils.replaceProductParts(entity, partPair, coreServices);
    }
};
export const addProductType = (catalog) => (entity) => {
    var _a;
    const productId = (_a = entity.getComponent(ComponentIds.PRODUCT_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.productRef;
    if (!productId)
        throw new Error("issues.. :(");
    const productCatalogData = catalog.products.find((product) => product.id.includes(productId));
    if (!(productCatalogData === null || productCatalogData === void 0 ? void 0 : productCatalogData.type))
        return;
    entity.addComponent(new ProductTypeComponent(productCatalogData.type));
};
